import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { InputDataUrl } from './InputDataUrl';
import { OutputValueDateArraySchema } from '../schema/InputDataSchema';

export interface OutputValueDateParams {
  outputDescriptionId: number;
  descriptionId: string;
  valueDate: string;
}

const getOutputValueDates = (params?: OutputValueDateParams) =>
  apiClient
    .get(expand(InputDataUrl.OUTPUT_VALUE_DATES, params))
    .then((response) => OutputValueDateArraySchema.parse(response.data));

export const useOutputValueDateQuery = createApiQueryHook(
  ['useOutputValueDate'],
  getOutputValueDates
);
